<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="u.expand ? 'collapsible expanded collapsible__bicycle' : 'collapsible collapsible__bicycle collapsed'" v-for="(u, uindex) in preset[0].bicycle">
					<div class="collapsible-heading">
							<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpand(uindex)">
								<b-img v-show="u.expand == true" :src="LaneClosureRequest.getBicycleLaneImageLight100(u.bicycleLaneId.value)" style="max-width: 50px;"></b-img>
								<b-img v-show="u.expand != true" :src="LaneClosureRequest.getBicycleLaneImage100(u.bicycleLaneId.value)" style="max-width: 50px;"></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand(uindex)">{{LaneClosureRequest.getBicycleLaneText(u.bicycleLaneId.value)}} <small v-html="getTitleText(uindex)"></small></div>
						<div class="collapsible-heading__review-blocks" @click="onToggleExpand(uindex)"><div class="flex-table"><div class="flex-table-cell">Review Blocks</div></div></div>
						<div class="collapsible-heading__toggle">
							<div class="flex-table">
							<b-button href="#" variant="collapsible"
							:class="u.expand ? ' flex-table-cell' : 'collapsed flex-table-cell'"
							:aria-expanded="u.expand ? 'true' : 'false'"
							:aria-controls="'collapseBicycleListing'+uindex"
							@click="onToggleExpand(uindex)"
							>
						<span class="when-opened">
						<font-awesome-icon icon="chevron-down" />
						</span>
						<span class="when-closed">
						<font-awesome-icon icon="chevron-right" />
						</span>
						</b-button>
							</div>
							</div>
							<button type="button" class="collapsible-heading__remove" title="Remove Bicycle Lane" @click="onRemoveAll(uindex)"><font-awesome-icon icon="trash" /></button>

						</div>
						</div>
					<b-collapse :id="'collapseBicycleListing'+uindex" :visible="u.expand" class="collapsible-entries">
						<div class="collapsible-entries__wrapper">
							<div class="is-entry">
									<div class="d-flex collapsible-entry">
										<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getBicycleLaneImage(u.bicycleLaneId.value)"></b-img></div>
										<div class="collapsible-entry__set-all-blocks flex-grow-1">SET AFFECTED BLOCKS</div>
										<div class="collapsible-entry__all-yes-button"><b-button variant="primary" type="button" @click="setAllYes(uindex)">Closing Bicycle Lane for All Blocks</b-button></div>
										<div class="collapsible-entry__all-no-button"><b-button variant="secondary" type="button" @click="setAllNo(uindex)">All Blocks Open</b-button></div>
									</div>
							</div>


							<div :class="classes(b2index, uindex)" v-for=" (b, b2index) in value" :key="'eblbindex-'+b2index+'-'+uindex+'-'+renderCounter">
									<div class="d-flex collapsible-entry">
										<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getBicycleLaneImage(u.bicycleLaneId.value)"></b-img></div>
										<div class="collapsible-entry__title flex-grow-1"><a href="#" @click="showOnMap(b.blockId, u)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong></a></div>
										<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, u)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
										<div class="collapsible-entry__switch">
											<div class="closing-open-switch-field">
												<input :id="switchId('eblbicycle',b2index,u.bicycleLaneId.value)"  class="closing-open-switch" :checked="isEntry(b2index,uindex)" type="checkbox" @change="toggleRemoveBlock(b2index,uindex)" >
												<label :for="switchId('eblbicycle',b2index,u.bicycleLaneId.value)"></label>
											</div>
										</div>
										<div class="collapsible-entry__delete-block-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="onRemoveBlock(b.blockId)"><span class="icon-trash"></span></b-button></div>
									</div>
								</div>


								<div class="is-not-entry">
										<div class="d-flex collapsible-entry">
										<div class="collapsible-entry__icon"><b-img :src="LaneClosureRequest.getBicycleLaneImage(u.bicycleLaneId.value)"></b-img></div>
											<div class="collapsible-entry__set-all-blocks flex-grow-1">Need to add or remove a street block from this request? Open the  map <b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button> and click on the street or block.</div>
										<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
										</div>
								</div>


						</div>
								</b-collapse>
					</div>

					<div v-if="$store.state.isMobile" :class="isExpanded(u) ? 'collapsible expanded collapsible__bicycle' : 'collapsible collapsible__bicycle collapsed'" v-for="(u, uindex) in preset[0].bicycle">
						<div class="collapsible-heading">
							<div class="d-flex">
							<div class="collapsible-heading__image cycle-mobile" @click="onToggleExpand(uindex)">
								<!-- <b-img v-show="u.expand == true" :src="LaneClosureRequest.getBicycleLaneImageLight100(u.bicycleLaneId.value)" style="max-width: 50px;"></b-img> -->
								<!-- <b-img v-show="u.expand != true" :src="LaneClosureRequest.getBicycleLaneImage100(u.bicycleLaneId.value)" style="max-width: 50px;"></b-img> -->
								<b-img :src="LaneClosureRequest.getBicycleLaneImage100(u.bicycleLaneId.value)" style="width: 50px; height: 50px !important;"></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand(uindex)">
								{{LaneClosureRequest.getBicycleLaneText(u.bicycleLaneId.value)}} <div class="collapsible-heading__subtitle" v-html="getTitleText(uindex)"></div>
								<!-- <div class="flex-table"><div class="flex-table-cell">Review Blocks</div></div> -->
							</div>
						<div class="collapsible-heading__toggle">
							<div class="flex-table">
							<b-button href="#" variant="collapsible"
							:class="u.expand ? ' flex-table-cell' : 'collapsed flex-table-cell'"
							:aria-expanded="u.expand ? 'true' : 'false'"
							:aria-controls="'collapseBicycleListing'+uindex"
							@click="onToggleExpand(uindex)"
							>
							<span>
								<font-awesome-icon icon="chevron-right" />
							</span>
						</b-button>
							</div>
							</div>
							<button type="button" class="collapsible-heading__remove" title="Remove Bicycle Lane" @click="onRemoveAll(uindex)"><font-awesome-icon icon="trash" /></button>

						</div>
						</div>
					</div>
					<div v-if="$store.state.isMobile">
						<transition name="slide-fade" tag="div">
					<div class="d-block section-slide-panel" v-if="showPanel">
						<div class="top-controls">
							<a @click="onSwipeRight">
								<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
							</a>
						</div>
							<div class="panels-body edit-lcr-panels-body panels-body-padded panels-no-menu">
								<div class="panels-nav-title" v-html="getNavTitle"></div>
							<template v-if="isExpanded(u)" v-for="(u, uindex) in preset[0].bicycle">
									<div class="panels-body-title">
										<b-img :src="LaneClosureRequest.getBicycleLaneImage(u.bicycleLaneId.value)"></b-img>
										<div class="flex-grow-1 pt-3" @click="onToggleExpand(uindex)">{{LaneClosureRequest.getBicycleLaneText(u.bicycleLaneId.value)}}</div>
									</div>
									<div class="panels-body-content"  v-keep-scroll-position>
										<div :class="classes(b2index, uindex)" v-for=" (b, b2index) in value" :key="'eblbindex-'+b2index+'-'+uindex+'-'+renderCounter">
												<div class="d-flex collapsible-entry">
													<div class="collapsible-entry__switch">
														<div class="closing-open-switch-field">
															<input :id="switchId('eblbicycle',b2index,u.bicycleLaneId.value)"  class="closing-open-switch" :checked="isEntry(b2index,uindex)" type="checkbox" @change="toggleRemoveBlock(b2index,uindex)" >
															<label :for="switchId('eblbicycle',b2index,u.bicycleLaneId.value)"></label>
														</div>
													</div>
													<div class="collapsible-entry__title flex-grow-1"><a href="#" @click="showOnMap(b.blockId, u)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong></a></div>
													<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, u)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
													<div class="collapsible-entry__delete-block-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="onRemoveBlock(b.blockId)"><span class="icon-trash"></span></b-button></div>
												</div>
											</div>
									<div class="is-not-entry">
											<div class="d-flex collapsible-entry">
												<div class="collapsible-entry__set-all-blocks flex-grow-1">Need to add or remove a street block from this request? Open the  map <b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button> and click on the street or block.</div>
											<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
											</div>
									</div>
									</div>
								</template>
								<div class="panels-apply">
									<div class="d-flex">
										<div class="panels-apply__close"><b-button @click="setAllYes(null)" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />Closing</b-button></div>
										<div class="panels-apply__open"><b-button @click="setAllNo(null)" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />Open</b-button></div>
										<div class="panels-apply__save"><b-button @click="onApplySingle()" variant="secondary" class="save-button" type="button"><span class="btn__icon"><img src="/img/assets/icon-checkmark-blue.svg"/></span><span class="btn__text">Apply</span></b-button></div>
									</div>
									</div>
								</div>
							</div>
						</transition>
					</div>

				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import Vue from 'vue'

export default {
	name: 'LaneClosureRequestBlockBicycleListing',
	props: ['value', 'preset', 'bicycleLaneId', 'expand', 'renderCounter'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			backup: {},
			showPanel:false,
		}
	},
		mounted() {
			this.showPanel = this.expand;
			Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
	     },
	     destroyed() {
			Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
	     },
   watch: {
   	'$store.state.isMobile' : function() {
   		this.showPanel = false;
   	},
   },
	computed: {
		getNavTitle() {
			return "Select Blocks to Close";
		},
		entries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.bicycle) {
					for (x = 0; x < entry.bicycle.length; x++) {
						if (entry.bicycle[x].bicycleLaneId.value == that.bicycleLaneId) {
							return true;
						}
					}
				}
				return false;
			})
		},
		nonEntries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.bicycle) {
					for (x = 0; x < entry.bicycle.length; x++) {
						if (entry.bicycle[x].bicycleLaneId.value == that.bicycleLaneId) {
							return false;
						}
					}
				}
				return true;
			})
		},
	},
	methods: {
		getExpandClasses(obj) {
			if (obj) {
				if (obj.expand) {
					return "collapsible expanded collapsible__bicycle";
				}
			}
			return "collapsible collapsible__bicycle collapsed";
		},
		isExpanded(u) {
			if (u) {
				if (typeof u.expand != "undefined") {
					return u.expand;
				}
			}
			return false;
		},
		classes: function(index,uindex) {
			if (this.isEntry(index,uindex)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		getTitleText(uindex) {
			let title = "";
			let qty = 0;
			let found = false;
			if (this.value && this.preset) {
				if (this.preset[0].bicycle[uindex]) {
				for (var xx = 0; xx < this.value.length; xx++) {
					found = false;
						for (var x = 0; x < this.value[xx].bicycle.length; x++) {
							if (this.value[xx].bicycle[x]) {
								if (this.value[xx].bicycle[x].bicycleLaneId.value == this.preset[0].bicycle[uindex].bicycleLaneId.value) {
							found = true;
						}
					}
						}

					if (found) {
						qty++;
					}
				}
			}
			}
			let blockText = "blocks";
			if (this.value.length == 1) {
				blockText = "block";
			}
			if (qty == 1) {
				title = qty + " of " + this.value.length + " " + blockText;
			} else {
				if (qty == 0) {
					title = "<span class='no-blocks-assigned'>assign blocks for closing</span>";
				} else {
					title = qty + " of " + this.value.length + " " + blockText;
				}
			}
			if (qty == this.value.length) {
				title = "all blocks";
			}
			if (this.$store.state.isMobile || qty == 0) {
				return title;
			} else {
				return " ("+title+")";
			}
		},

		isEntry: function(index,uindex) {
			if (this.value && this.preset) {
				if (this.value[index] && this.preset[0]) {
					if (this.preset[0].bicycle[uindex]) {
						for (var x = 0; x < this.value[index].bicycle.length; x++) {
							if (this.value[index].bicycle[x].bicycleLaneId.value == this.preset[0].bicycle[uindex].bicycleLaneId.value) {
							return true;
							}
						}
				}
			}
			}
			return false;
		},
		canBeAdded: function(index,uindex) {
			if (this.value) {
				if (this.value[index]) {
					for (var uniqueIndex = 0; uniqueIndex < this.preset[0].bicycle.length; uniqueIndex++) {
						for (var x = 0; x < this.value[index].bicycle.length; x++) {
							if (this.preset[0].bicycle[uniqueIndex]) {
								if (
								 this.value[index].bicycle[x].bicycleLaneId.value == this.preset[0].bicycle[uniqueIndex].bicycleLaneId.value
								) {
									return false;
								}
							}
						}
					}
				}
			}

			return true;
		},
		switchId(prefix,block,id) {
			return prefix+"-"+block+"-"+id;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		showOnMap: function(id, bicycleField) {
			Vue.prototype.$bus.$emit("block:show-on-map",{id, type: "bicycle", laneId: bicycleField.bicycleLaneId.value});
		},
		showMap: function() {
			Vue.prototype.$bus.$emit("map:toggle", null);
			this.$store.dispatch("map/zoomAllBlocks", null);

		},

		toggleRemoveBlock: function(index,uindex) {
			if (this.isEntry(index,uindex)) {
				Vue.prototype.$bus.$emit("block:list-remove-bicycle",{bicycleLaneId:this.preset[0].bicycle[uindex].bicycleLaneId.value, blockId:this.value[index].blockId});
			} else {
				Vue.prototype.$bus.$emit("block:list-add-bicycle",{bicycleLaneId:this.preset[0].bicycle[uindex].bicycleLaneId.value, blockId:this.value[index].blockId});
			}
		},
		setAllYes: function(uindex) {
			if (uindex == null) {
				uindex = 0;
				for (uindex = 0; uindex < this.preset[0].bicycle.length; uindex++) {
					if (this.isExpanded(this.preset[0].bicycle[uindex])) {
						Vue.prototype.$bus.$emit("block:list-add-bicycle",{bicycleLaneId:this.preset[0].bicycle[uindex].bicycleLaneId.value, blockId:null});
					}
				}
			} else {
				if (this.isExpanded(this.preset[0].bicycle[uindex])) {
					Vue.prototype.$bus.$emit("block:list-add-bicycle",{bicycleLaneId:this.preset[0].bicycle[uindex].bicycleLaneId.value, blockId:null});
				}
			}


		},
		setAllNo: function(uindex) {
			if (uindex == null) {
				uindex = 0;
				for (uindex = 0; uindex < this.preset[0].bicycle.length; uindex++) {
					if (this.isExpanded(this.preset[0].bicycle[uindex])) {
						Vue.prototype.$bus.$emit("block:list-remove-bicycle",{bicycleLaneId:this.preset[0].bicycle[uindex].bicycleLaneId.value, blockId:null});
					}
				}
			} else {
				if (this.isExpanded(this.preset[0].bicycle[uindex])) {
					Vue.prototype.$bus.$emit("block:list-remove-bicycle",{bicycleLaneId:this.preset[0].bicycle[uindex].bicycleLaneId.value, blockId:null});
				}
			}

		},
		onRemoveBlock(blockID) {
			Vue.prototype.$bus.$emit("map:block-remove", blockID);
		},
		onRemoveAll(uindex) {
				Vue.prototype.$bus.$emit("preset-block:remove-bicycle",{index:uindex});
		},
		onApply: function(uindex) {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				if (that.preset[0].bicycle[uindex]) {
					Vue.prototype.$bus.$emit("preset-block:expand-bicycle",{index:uindex,expand:!that.preset[0].bicycle[uindex].expand});
				}
			}, 250);
		},

		onSwipeRight() {
			this.showPanel = false;
			setTimeout(() => {
				Vue.prototype.$bus.$emit("preset-block:collapse-bicycles");
			}, 250);
		},

		onToggleExpand: function(uindex) {
			this.showPanel = !this.showPanel;
			Vue.prototype.$bus.$emit("preset-block:expand-bicycle",{index:uindex,expand:!this.preset[0].bicycle[uindex].expand});
		},
		onToggleExpandSingle(uindex) {
			this.showPanel = !this.showPanel;
			Vue.prototype.$bus.$emit("preset-block:expand-single-bicycle",{index:uindex,expand:!this.preset[0].bicycle[uindex].expand});
		},

		onApplySingle: function(uindex) {
			setTimeout(() => {
				this.showPanel = false;
				Vue.prototype.$bus.$emit("preset-block:collapse-bicycles");
			}, 0);

		},

	}
}
</script>
